const API_BASE_URL = 'https://lbstoreivp.com.br/api/'

export default API_BASE_URL
